module.exports = __webpack_public_path__ + "img/ultra_2_01.35300b04.jpg";